import { IncidentReport, SearchReportsParams, SearchReportsResult } from '@mobileTypes'

import { commonAPI } from '@redux/api/common.api'

import { getMobileReportsUrl } from '@constants'

export const mobileReportsApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchMobileReports: build.query<SearchReportsResult, SearchReportsParams>({
      query: params => ({
        url: getMobileReportsUrl(),
        params: {
          ...(params.query ? { query: params.query } : {}),
          ...(params.archived ? { archived: true } : {}),
          limit: params.limit,
          offset: params.offset,
        },
      }),
      providesTags: ['AllMobileReports'],
    }),

    fetchMobileReportById: build.query<IncidentReport, { incidentId: string; archived?: boolean }>({
      query: ({ incidentId, archived }) => ({
        url: `${getMobileReportsUrl()}/${encodeURIComponent(incidentId)}`,
        params: archived ? { archived: true } : undefined,
      }),
      providesTags: ['SingleMobileReport'],
    }),

    archiveMobileReports: build.mutation<{ moved: number }, { incidentIds: string[] }>({
      query: body => ({
        url: `${getMobileReportsUrl()}/archive`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AllMobileReports', 'SingleMobileReport'],
    }),

    restoreMobileReports: build.mutation<{ moved: number }, { incidentIds: string[] }>({
      query: body => ({
        url: `${getMobileReportsUrl()}/restore`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AllMobileReports', 'SingleMobileReport'],
    }),
  }),
})

export const {
  useFetchMobileReportsQuery,
  useFetchMobileReportByIdQuery,
  useArchiveMobileReportsMutation,
  useRestoreMobileReportsMutation,
} = mobileReportsApi
